/*
 * Copyright (c) 2020 JCA Electronics , Winnipeg, MB. All rights reserved.
 */

export interface MachineKey {
  machineId: string;
  MachineName?: string;
  AccountID?: string;
}

// Converts JSON strings to/from your types
export class ConvertMachineKey {
  public static toMachineKey(json: string): MachineKey[] {
    return JSON.parse(json);
  }
}
